import { useEffect, useState } from "react";
import { useMutation } from "convex/react";
import { api } from "../../../convex/_generated/api";

const QA_ROLES = ["agency_admin", "account_manager", "designer"] as const;
type QaRole = (typeof QA_ROLES)[number];

function requestedRole(): QaRole | null {
  const value = new URLSearchParams(window.location.search).get("role");
  return QA_ROLES.includes(value as QaRole) ? (value as QaRole) : null;
}

export function DevQaProvisionPage() {
  const role = requestedRole();
  const provision = useMutation(api.identity.provisionCurrentUser);
  const [status, setStatus] = useState("starting");
  const [error, setError] = useState("");

  useEffect(() => {
    if (import.meta.env.PROD) {
      setStatus("unavailable");
      return;
    }
    if (!role) {
      setStatus("invalid-role");
      return;
    }

    let active = true;
    void provision({
      organizationSlug: "ohdelices",
      organizationName: "Oh Delices Creative",
      role,
    })
      .then(() => {
        if (active) setStatus("complete");
      })
      .catch((caught) => {
        if (!active) return;
        setError(caught instanceof Error ? caught.message : "Provisioning failed");
        setStatus("failed");
      });

    return () => {
      active = false;
    };
  }, [provision, role]);

  return (
    <main data-testid="qa-provision-result" data-status={status}>
      <h1>Development QA provisioning</h1>
      <p>Role: {role ?? "invalid"}</p>
      <p>Status: {status}</p>
      {error ? <p role="alert">{error}</p> : null}
    </main>
  );
}
